app.directive('incDec', ['$interval', function ($interval) {
    return {
        link: function (scope, element, attrs) {
            var updateInterval, count;
            var disableValidation = !!attrs['disableValidation'];

            scope.upDown = function (params) {

                $interval.cancel(updateInterval);
                return upDown(params);
            };

            scope.upDownRepeat = function (params) {
                $interval.cancel(updateInterval);
                count = 0;
                updateInterval = $interval(function () {
                    return upDown(params);
                }, 150);
            };

            scope.upDownStop = function () {
                $interval.cancel(updateInterval);
            };

            function upDown(params) {
                var value, step, coef = Math.pow(10, params.digits);

                function checkRange(value, min, max) {
                    if (value >= parseFloat(min) && value <= parseFloat(max)) {
                        return value;
                    }
                }

                step = params.step;
                value = params.model.value;

                if (params.hasOwnProperty('speedStep')) {
                    var data = params.speedStep;
                    count++;
                    if (data && typeof data === 'object') {
                        Object.keys(data).forEach(function (k) {
                            if (count > parseInt(k)) {
                                // step = data[k];
                                step = data[k];
                            }
                        })
                    }
                }

                var _value = parseFloat((Math.max((((value * coef) + (params.direction === 'increase' ? step : -1 * step)) / coef), 0).toFixed(params.digits)));
                if (params.min && params.max) {

                    if (!params.model.value) params.model.value = params.min;

                    if (disableValidation) {
                        params.model.value = _value;
                    } else {
                        if (checkRange(_value, params.min, params.max)) {
                            return params.model.value = _value;
                        }
                    }

                    /*if (checkRange(_value, params.min, params.max)) {
                        return params.model.value = _value;
                    } else if (!params.model.value || _value < params.min) {
                        return params.model.value = params.min;
                    } else if (_value > params.max) {
                        return params.model.value = params.max;
                    }*/
                } else {
                    return params.model.value = _value;
                }
            }
        }
    }
}]);
